<template>
  <div class="Profile">
    <h3 class="mb-3 text-right">Perfil de usuario</h3>
    <b-card
      header-tag="header"
      header-class="card-color"
      class="mb-4"
      style="border-radius: 25px"
    >
      <template #header>
        <b-row align-v="center" align-h="between">
          <b-col lg="8" md="8" sm="7" cols="7">
            <div class="text-left card-title-white">Editar perfil</div>
          </b-col>
          <b-col lg="3" md="3" sm="4" cols="5">
            <b-button
              v-b-modal.modal-bank
              style="border-radius: 15px; border: none"
              class="btn-card-color pl-3 pr-3 pb-2 pt-2"
              size="sm"
            >
              <span class="text-font-white">Agregar cuenta bancaria</span>
            </b-button>
          </b-col>
        </b-row>
      </template>
      <b-card-text>
        <b-list-group class="p-2">
          <b-container>
            <b-row>
              <b-col lg="6" class="mb-3">
                <b-row align-h="center">
                  <b-col lg="10" md="10" sm="10" cols="12">
                    <h5 class="text-light-black text-left">Nombres</h5>
                    <b-form-input
                      id="input-live"
                      v-model="name"
                      size="sm"
                      class="shadow-sm bg-white rounded"
                      trim
                    ></b-form-input>
                  </b-col>

                  <b-col lg="10" md="10" sm="10" cols="12">
                    <h5 class="text-light-black mt-3 text-left">Apellidos</h5>
                    <b-form-input
                      v-model="last_name"
                      placeholder=""
                      size="sm"
                      class="shadow-sm bg-white rounded"
                    ></b-form-input>
                  </b-col>

                  <b-col lg="10" md="10" sm="10" cols="12">
                    <h5 class="text-light-black mt-3 text-left">País</h5>

                    <b-form-select
                      v-model="country"
                      id="country"
                      size="sm"
                      class="shadow-sm bg-white rounded"
                      :options="countryTmp"
                    ></b-form-select>
                  </b-col>
                  <b-col lg="6" md="6" sm="9" cols="12"> </b-col>
                  <div></div>

                  <b-col
                    lg="10"
                    md="10"
                    sm="10"
                    cols="12"
                    v-if="country == 'Venezuela'"
                  >
                    <h5 class="text-light-black mt-3 text-left">Ciudad</h5>
                    <b-form-select
                      id="input-live"
                      v-model="city"
                      :options="stateTmp"
                      size="sm"
                      class="shadow-sm bg-white rounded"
                      trim
                    ></b-form-select>
                  </b-col>

                  <b-col lg="10" md="10" sm="10" cols="12">
                    <h5 class="text-light-black text-left mt-3">Teléfono</h5>
                    <b-form-input
                      v-model="phone"
                      type="number"
                      placeholder=""
                      size="sm"
                      class="shadow-sm bg-white rounded"
                    ></b-form-input>
                  </b-col>
                  <b-col>
                    <b-button
                      style="border-radius: 15px; border: none"
                      class="btn-card-color mt-3 text-left pl-4 pr-4 pb-2 pt-2"
                      size="lg"
                      @click="UpdateUser()"
                    >
                      <span v-if="!progress" class="text-font-white"
                        style="font-size: 16px">Guardar cambios</span
                      >
                      <span v-if="progress" class="text-font-white"
                        ><b-spinner type="grow" label="Spinning"></b-spinner
                        >Cargando</span
                      >
                    </b-button>
                  </b-col>
                  
                </b-row>
              </b-col>
              <b-col lg="6">
                <b-row align-v="center" align-h="center">
                  <b-col lg="6" class="mb-3">
                    <img
                      :src="picture"
                      height="200px"
                      width="200px"
                      style="border-radius: 200px"
                      alt=""
                    />
                  </b-col>
                  <b-col lg="6">
                    <!-- <p>Se recomienda una foto con las mismas dimensiones</p> -->
                    <b-button
                      style="border-radius: 15px; border: none"
                      class="btn-card-color pl-4 pr-4 pb-2 pt-2 mb-3"
                      size="lg"
                      @click="changePicture()"
                    >
                      <span class="text-font-white" style="font-size: 16px">Cambiar foto</span>
                    </b-button>
                  </b-col>
                  <b-col lg="6" md="6" sm="6" cols="6">
                    <h5
                      class="text-light-black text-left"
                      style="font-size: 17px"
                    >
                      Fecha de ingreso:
                    </h5>
                  </b-col>
                  <b-col lg="6" md="6" sm="6" cols="6">
                    <h5 class="text-light-black" style="font-size: 17px">
                      {{ date.substr(0, 10).split("-").reverse().join("-") }}
                    </h5>
                  </b-col>
                </b-row>
                <b-row align-v="center" align-h="center" class="mt-3">
                  <b-col lg="6" md="6" sm="6" cols="6">
                    <h5
                      class="text-light-black text-left"
                      style="font-size: 17px"
                    >
                      Cuentas bancarias registradas:
                    </h5>
                  </b-col>
                  <b-col lg="6" md="6" sm="6" cols="6" v-if="bank.length == 0">
                    <h5 class="text-light-black" style="font-size: 17px">
                      {{ bank.length }}
                    </h5>
                  </b-col>
                  <b-col lg="6" md="6" sm="6" cols="6" v-if="bank.length != 0">
                    <b-button
                      style="border-radius: 15px; border: none"
                      class="btn-card-color pl-4 pr-4 pb-2 pt-2"
                      size="lg"
                      v-b-modal.modal-banks
                    >
                      <span class="text-font-white" style="font-size: 16px">Ver cuentas</span>
                    </b-button>
                  </b-col>
                </b-row>
              <!--  <b-row align-v="center" align-h="center" class="mt-3">
                  <b-col lg="6" md="6" sm="6" cols="6">
                    <h5
                      class="text-light-black text-left"
                      style="font-size: 17px"
                    >
                      2FA - Autenticación de dos pasos:
                    </h5>
                  </b-col>
                  <b-col
                    lg="6"
                    md="6"
                    sm="6"
                    cols="6"
                    v-if="user.two_factor_enabled == 1"
                  >
                    <h5
                      class="text-light-black"
                      style="font-size: 17px; color: green"
                    >
                      Activada
                    </h5>
                  </b-col>
                  <b-col
                    lg="6"
                    md="6"
                    sm="6"
                    cols="6"
                    v-if="user.two_factor_enabled == 0"
                  >
                    <h5
                      class="text-light-black"
                      style="font-size: 17px; color: red"
                    >
                      Desactivada
                    </h5>
                    
                  </b-col>
                </b-row>-->
                <b-row
                  align-h="center"
                  align-v="center"
                  class="mt-3"
                  v-if="user.two_factor_enabled == 0"
                >
                 <!-- <b-button
                    style="border-radius: 15px; border: none"
                    class="btn-card-color pl-3 pr-3 pb-2 pt-2"
                    size="lg"
                    @click="
                      disable = false;
                      title = 'Habilitar 2FA';
                      get2FA();
                    "
                    v-b-modal.modal-2FA
                  >
                    <span class="text-font-white" style="font-size: 16px">Configurar 2FA</span>
                  </b-button>-->
                  <b-button
                      style="border-radius: 15px; border: none"
                      class="ml-2 text-left pl-3 pr-3 pb-2 pt-2"
                      size="lg"
                      v-b-modal.modal-password
                    >
                      <span class="text-font-white" style="font-size: 16px">Cambiar contraseña</span>
                    </b-button>
                </b-row>
                <b-row
                  align-h="center"
                  align-v="center"
                  class="mt-3"
                  v-if="user.two_factor_enabled == 1"
                >
                  <b-button
                    style="border-radius: 15px; border: none"
                    class="btn-card-color pl-3 pr-3 pb-2 pt-2"
                    size="lg"
                    @click="
                      step = 2;
                      disable = true;
                      title = 'Deshabilitar 2FA';
                      sendEmail();
                    "
                    v-b-modal.modal-2FA
                  >
                    <span class="text-font-white" style="font-size: 16px">Deshabilitar 2FA</span>
                  </b-button>
                  <b-button
                      style="border-radius: 15px; border: none"
                      class="ml-2 text-left pl-3 pr-3 pb-2 pt-2"
                      size="lg"
                      v-b-modal.modal-password
                    >
                      <span class="text-font-white" style="font-size: 16px">Cambiar contraseña</span>
                    </b-button>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </b-list-group>
      </b-card-text>
    </b-card>
    <b-modal
      id="modal-bank"
      ref="modal"
      title-class="text-font-black"
      title="Agregar una cuenta"
      hide-footer
      size="lg"
      @show="resetModal"
      @hidden="resetModal"
    >
      <b-container>
        <b-form-group
          label="Cuenta a regitrar"
          label-for="account"
          label-class="text-light-black"
          invalid-feedback="Cuenta requerida"
        >
          <b-form-select
            id="account_type"
            v-model="type"
            :options="typeTmp"
            required
          ></b-form-select>
        </b-form-group>
      </b-container>

      <div v-if="type == 1">
        <form ref="form" @submit.stop.prevent="AddBankAccount">
          <b-container>
            <b-row>
              <b-col lg="6">
                <b-form-group
                  label="Nombre del banco*"
                  label-for="Username"
                  label-class="text-light-black"
                  invalid-feedback="Nombre requerido"
                >
                  <b-form-input
                    id="Username"
                    v-model="nameBank"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group
                  label="Correo electrónico de la cuenta"
                  label-for="email"
                  label-class="text-light-black"
                  invalid-feedback="Email requerido"
                >
                  <b-form-input
                    type="email"
                    v-model="emailBank"
                    id="email"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group
                  label="Tipo de cuenta"
                  label-for="account"
                  label-class="text-light-black"
                  invalid-feedback="Cuenta requerida"
                >
                  <b-form-select
                    id="account_type"
                    v-model="account_type"
                    :options="optionsTmp"
                    disabled
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group
                  label="Número de cuenta *"
                  label-for="ach"
                  label-class="text-light-black"
                  invalid-feedback="Número de cuenta requerido"
                >
                  <b-form-input
                    v-model="account_number"
                    id="account"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group
                  label="ACH *"
                  label-for="email"
                  label-class="text-light-black"
                  invalid-feedback="ACH requerido"
                >
                  <b-form-input id="ACH" v-model="ach" required></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group
                  label="Ubicación de la cuenta"
                  label-for="location"
                  label-class="text-light-black"
                  invalid-feedback="Ub requerido"
                >
                  <b-form-input v-model="location" id="location"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="text-font-black mb-3">* Campos obligatorios</div>
            <b-row align-h="end" align-v="center">
              <b-col lg="2" sm="6" cols="6">
                <b-button
                  style="border-radius: 12px; border: none"
                  class="p-3"
                  size="sm"
                  @click="
                    cancel = true;
                    resetModal2();
                  "
                >
                  <span class="text-font-white">Cancelar</span>
                </b-button>
              </b-col>
              <b-col lg="2" sm="6" cols="6">
                <b-button
                  style="border-radius: 12px; border: none"
                  class="btn-card-color p-3"
                  size="sm"
                  @click="AddBankAccount()"
                >
                  <span class="text-font-white">Agregar</span>
                </b-button>
              </b-col>
            </b-row>
          </b-container>

          <div v-show="progress" class="text-center text-primary">
            <b-spinner small class="align-middle"></b-spinner>
            <strong class="ml-2">Cargando...</strong>
          </div>
        </form>
      </div>
      <div v-if="type == 2">
        <form ref="form" @submit.stop.prevent="AddBankAccount">
          <b-container>
            <b-row>
              <b-col lg="6">
                <b-form-group
                  label="Nombre de la cuenta *"
                  label-for="Username"
                  label-class="text-light-black"
                  invalid-feedback="Nombre requerido"
                >
                  <b-form-input
                    id="Username"
                    v-model="name2"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col lg="6">
                <b-form-group
                  label="Tipo de cuenta *"
                  label-for="account"
                  label-class="text-light-black"
                  invalid-feedback="Cuenta requerida"
                >
                  <b-form-select
                    id="account_type"
                    v-model="account_type"
                    :options="optionsTmp"
                    required
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="text-font-black mb-3">* Campos obligatorios</div>
            <b-row align-h="end" align-v="center" v-show="!progress">
              <b-col lg="2" sm="6" cols="6">
                <b-button
                  style="border-radius: 12px; border: none"
                  class="p-3"
                  size="sm"
                  @click="
                    cancel = true;
                    resetModal2();
                  "
                >
                  <span class="text-font-white">Cancelar</span>
                </b-button>
              </b-col>
              <b-col lg="2" sm="6" cols="6">
                <b-button
                  style="border-radius: 12px; border: none"
                  class="btn-card-color p-3"
                  size="sm"
                  @click="AddBankAccount()"
                >
                  <span class="text-font-white">Agregar</span>
                </b-button>
              </b-col>
            </b-row>
          </b-container>

          <div v-show="progress" class="text-center text-primary">
            <b-spinner small class="align-middle"></b-spinner>
            <strong class="ml-2">Cargando...</strong>
          </div>
        </form>
      </div>
    </b-modal>
    <b-modal
      id="modal-2FA"
      ref="modal"
      title-class="text-font-black"
      :title="title"
      hide-footer
      @hidden="resetModal"
    >
      <div v-if="step == 1">
        <b-container>
          <b-row>
            <b-col>
              <div class="text-font-black">
                Escanea el código QR con la aplicación de autenticación
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col align-self="center">
              <div>
                <img :src="qr" alt="" />
              </div>
            </b-col>
            <b-col></b-col>
          </b-row>
          <b-row>
            <b-col align-self="center">
              <div class="text-font-black" style="font-size: 13px">
                También puedes copiar y pegar el código en la aplicación
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col lg="12">
              <b-form-input
                v-model="code"
                placeholder=""
                size="sm"
                class="shadow-sm bg-white rounded"
                disabled
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col align-self="center">
              <div class="text-font-black" style="font-size: 13px">
                Recuerda guardar este código ya que es el que te permitirá
                recuperar tus datos en caso de que cambies el teléfono.
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col></b-col>
            <b-col align-self="end">
              <b-button
                style="border-radius: 12px; border: none"
                class="btn-card-color p-3"
                right
                size="sm"
                @click="
                  disable = false;
                  sendEmail();
                  step++;
                "
              >
                <span class="text-font-white">Continuar</span>
              </b-button>
            </b-col>
            <b-col></b-col>
          </b-row>
        </b-container>
      </div>
      <div v-if="step == 2">
        <b-container>
          <b-row>
            <b-col>
              <div class="text-font-black mb-3">
                Colocar el código que se ha enviado a su correo
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col align-self="center">
              <b-input-group size="md">
                <b-form-input
                  v-model="emailcode"
                  id="filterInput"
                  placeholder="Coloca el código de verificación"
                ></b-form-input>
                <b-input-group-append>
                  <b-button @click="sendEmail()">Volver a enviar</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col align-self="center">
              <div class="text-font-black">
                Colocar el código de 6 digitos de la aplicación autenticación
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col lg="12">
              <b-form-input
                v-model="code2"
                placeholder=""
                size="sm"
                class="shadow-sm bg-white rounded"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col></b-col>
            <b-col align-self="end">
              <b-button
                v-show="!progress"
                style="border-radius: 12px; border: none"
                class="btn-card-color p-3"
                :disabled="checkAuth"
                @click="Verificate2FA()"
                size="sm"
              >
                <span class="text-font-white" 
                  >Continuar</span
                >
              </b-button>
            </b-col>
            <b-col></b-col>
          </b-row>
        </b-container>
      </div>
  
      <div v-show="progress" class="text-center text-primary">
        <b-spinner small class="align-middle"></b-spinner>
        <strong class="ml-2">Cargando...</strong>
      </div>
    </b-modal>
    <b-modal
      id="modal-banks"
      ref="modal"
      title-class="text-font-black"
      title="Cuentas bancarias registradas"
      hide-footer
    >
      <b-list-group class="p-2" v-for="account of bank" :key="account.id">
        <b-list-group-item
          href="#"
          class="flex-column align-items-start"
          style="border-radius: 15px; border-color: #121419"
        >
          <b-row align-v="center" align-h="start">
            <b-col md="3 " cols="12">
              <img src="../assets/LogoSSBG.png" height="50px" alt="" />
            </b-col>
            <b-col md="3" cols="12">
              <h5 class="mb-1 text-font-black">
                {{ account.name }}
              </h5>
              <p class="mb-1 text-light-black">
                <strong
                  >#*******{{
                    account.number.substr(
                      account.number.length - 4,
                      account.number.length
                    )
                  }}</strong
                >
              </p>
            </b-col>
            <b-col md="6" cols="12">
              <h5 class="mb-1 text-font-black">
                {{ account.email }}
              </h5>
              <p class="mb-1 text-light-black">
                <strong
                  >ACH*******{{
                    account.ach.substr(
                      account.number.length - 4,
                      account.number.length
                    )
                  }}</strong
                >
              </p>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </b-modal>
    <b-modal
      id="modal-password"
      ref="modal"
      title-class="text-font-black"
      title="Cambiar contraseña"
      hide-footer
      @show="resetModal"
      @hidden="resetModal"
    >
      <b-container>
        <b-form-group
          label="Antigua contraseña"
          label-for="pass"
          invalid-feedback
        >
          <b-form-input
            id="old_pass"
            type="password"
            v-model="old_pass"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Contraseña nueva"
          label-for="pass"
          invalid-feedback
        >
          <b-form-input
            id="pass"
            type="password"
            v-model="pass"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label="Repita la nueva contraseña"
          label-for="pass1"
          invalid-feedback="Las contraseñas no coinciden"
        >
          <b-form-input
            id="pass1"
            type="password"
            v-model="pass1"
            required
          ></b-form-input>
        </b-form-group>

        <b-row align-h="end" align-v="center" v-show="!progress">
          <b-col lg="3" sm="6" cols="6">
            <b-button
              style="border-radius: 12px; border: none"
              class="p-3"
              size="sm"
              @click="
                cancel = true;
                resetModal2();
              "
            >
              <span class="text-font-white">Cancelar</span>
            </b-button>
          </b-col>
          <b-col lg="3" sm="6" cols="6">
            <b-button
              style="border-radius: 12px; border: none"
              class="btn-card-color p-3"
              size="sm"
              @click="changeUserPass()"
            >
              <span class="text-font-white">Agregar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>

      <div v-show="progress" class="text-center text-primary">
        <b-spinner small class="align-middle"></b-spinner>
        <strong class="ml-2">Cargando...</strong>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "Profile",
  data() {
    return {
      progress: false,
      name: null,
      nameBank: null,
      emailBank: null,
      last_name: null,
      email: null,
      country: null,
      city: null,
      phone: "",
      date: "",
      location: "",
      ach: "",
      account_number: "",
      picture: Cookies.get("picture"),
      id: Cookies.get("id"),
      qr: "",
      code: "",
      code2: "",
      emailcode: "",
      disable: null,
      step: 1,
      title: "",
      user: [],
      countryTmp: [],
      states: [],
      stateTmp: [],
      pass: "",
      pass1: "",
      old_pass: "",
      type: 1,
      account_type: "2",
      optionsTmp: [{ value: "2", text: "Banco de usuario" }],
      typeTmp: [{ value: 1, text: "Cuenta Bancaria" }],
      bank: [],
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.me,
    }),
    checkAuth() {
      return this.code2.length == 6 ? false : true;
    },
  },
  mounted() {
    this.getCountry();
    this.getState();
    this.getDataUser();
    this.AllBank();
  },

  methods: {
    ...mapActions([
      "UserbyId",
      "UserUpdate",
      "AllCountry",
      "AllStates",
      "UpdatePicture",
      "Generate2FA",
      "SendEmail",
      "Enable2FA",
      "Disable2FA",
      "CreateBankAccount",
      "getBank",
      "ChangePassword",
    ]),
    AllBank() {
      this.getBank(this.id)
        .then((response) => {
          
          if (response.code == 200) {
            this.bank = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        });
    },
    resetModal() {
      this.step1 = 1;
    },
    resetModal2() {
      if (this.cancel) {
        this.$nextTick(() => {
          this.$bvModal.hide("modal-bank");
        });
        this.cancel = false;
      }
      this.nameBank = "";
      this.email = "";
      this.account_type = "2";
      this.account_number = "";
      this.ach = "";
    },
    AddBankAccount() {
      if (this.type == 2) {
        if (this.name2 == "" || this.account_type == null) {
          Swal.fire({
            title: "¡Atención!",
            text: "Por favor llene los campos",
            icon: "warning",
          });
        } else {
          this.progress = true;
          let form = {
            user_id: this.id,
            name: this.name2,
            type_account: this.account_type,
          };
          this.CreateAccount(form)
            .then((response) => {
              console.log(response);
              if (response.code == 200) {
                Swal.fire({
                  title: "Listo",
                  text: "Su cuenta ha sido agregada con éxito",
                  icon: "success",
                });
                this.$nextTick(() => {
                  this.$bvModal.hide("modal-bank");
                });
                this.AllAccount();
                this.progress = false;
              } else {
                this.progress = false;

                Swal.fire({
                  title: "Error",
                  text: "No se pudo agregar la cuenta",
                  icon: "error",
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.progress = false;

              Swal.fire({
                title: "Error",
                text: "Ha ocurrido un error, intente más tarde",
                icon: "error",
              });
            });
        }
      } else {
        console.log(
          this.nameBank,
          this.account_number,
          this.ach,
          this.emailBank
        );
        if (
          this.nameBank == "" ||
          this.account_number == "" ||
          this.ach == "" ||
          this.emailBank == null
        ) {
          Swal.fire({
            title: "¡Atención!",
            text: "Faltan campos por llenar",
            icon: "warning",
          });
        } else {
          this.progress = true;
          let form = {
            user_id: this.id,
            email: this.emailBank,
            ach: this.ach,
            number: this.account_number,
            name: this.nameBank,
            location: this.location,
            type_user_bank_id: this.account_type,
          };
          this.CreateBankAccount(form)
            .then((response) => {
              console.log(response);
              if (response.code == 200) {
                Swal.fire({
                  title: "Listo",
                  text: "Su cuenta ha sido agregada con éxito",
                  icon: "success",
                });
                this.$nextTick(() => {
                  this.$bvModal.hide("modal-bank");
                });
                this.AllBank();
                this.progress = false;
              } else {
                this.progress = false;

                Swal.fire({
                  title: "Error",
                  text: "No se pudo agregar la cuenta",
                  icon: "error",
                });
              }
            })
            .catch((error) => {
              console.log(error);
              this.progress = false;

              Swal.fire({
                title: "Error",
                text: "Ha ocurrido un error, intente más tarde",
                icon: "error",
              });
            });
          /* if (this.account_number.length != 20) {
            Swal.fire({
              title: "¡Atención!",
              text: "El número de cuenta debe ser de 20 números",
              icon: "warning",
            });
          } else {
            this.progress = true;
            let form = {
              user_id: this.id,
              email: this.emailBank,
              ach: this.ach,
              number: this.account_number,
              name: this.nameBank,
              location: this.location,
              type_user_bank_id: this.account_type,
            };
            this.CreateBankAccount(form)
              .then((response) => {
                console.log(response);
                if (response.code == 200) {
                  Swal.fire({
                    title: "Listo",
                    text: "Su cuenta ha sido agregada con éxito",
                    icon: "success",
                  });
                  this.$nextTick(() => {
                    this.$bvModal.hide("modal-bank");
                  });
                  this.AllBank();
                  this.progress = false;
                } else {
                  this.progress = false;

                  Swal.fire({
                    title: "Error",
                    text: "No se pudo agregar la cuenta",
                    icon: "error",
                  });
                }
              })
              .catch((error) => {
                console.log(error);
                this.progress = false;

                Swal.fire({
                  title: "Error",
                  text: "Ha ocurrido un error, intente más tarde",
                  icon: "error",
                });
              });
          } */
        }
      }
    },
    getDataUser() {
      this.UserbyId(this.id).then((response) => {
        if (response.code == 200) {
          let data = response.data;
          this.user = data;
          this.name = data.first_name;
          this.last_name = data.last_name;
          this.country = data.country;
          this.city = data.state;
          this.phone = data.phone;
          this.email = data.email;
          this.picture = data.profile_picture;
          this.date = data.created_at;
        }
      });
    },
    UpdateUser() {
      if (
        this.name != null &&
        this.last_name != null &&
        this.country != null &&
        this.phone != null
      ) {
        if (this.country == "Venezuela" && this.city == null) {
          Swal.fire({
            title: "¡Atención!",
            text: "Debe seleccionar un estado",
            icon: "warning",
          });
        } else {
          this.progress = true;
          if (this.country != "Venezuela") {
            this.city = "";
          }
          let form = {
            id: this.id,
            params: {
              first_name: this.name,
              last_name: this.last_name,
              country: this.country,
              email: this.email,
              state: this.city,
              phone: this.phone,
            },
          };
          this.UserUpdate(form).then((response) => {
            if (response.code == 200) {
              Swal.fire({
                title: "Listo",
                text: "Sus datos han sido actualizados",
                icon: "success",
              });
              Cookies.set("picture", this.picture);
              this.progress = false;
              this.getDataUser();
            } else {
              this.progress = false;

              Swal.fire({
                title: "Error",
                text: "",
                icon: "warning",
              });
            }
          });
        }
      } else {
        Swal.fire({
          title: "¡Atención!",
          text: "No puede dejar campos vacios",
          icon: "warning",
        });
      }
    },
    async changePicture() {
      const { value: file } = await Swal.fire({
        title: "Seleccionar una imagen",
        input: "file",
        inputAttributes: {
          accept: "image/*",
          "aria-label": "Upload your profile picture",
        },
      });

      if (file) {
        this.progress = true;
        let datos = new FormData();
        datos.append("profile_picture", file);
        let form = {
          data: datos,
          id: this.id,
        };
        const reader = new FileReader();
        reader.onload = (e) => {
          this.UpdatePicture(form)
            .then((data) => {
              this.progress = false;
              if (data.code == 200) {
                this.img = data.data.profile_picture;
                //this.userPicture = data.data.profile_picture;
                Swal.fire({
                  title: "Imagen subida",
                  imageUrl: e.target.result,
                  imageAlt: "The uploaded picture",
                });
                Cookies.set("picture", this.img);
                this.$router.go();
              } else if (data.code == 400) {
                Swal.fire({
                  title: "Error al subir la imagen",
                  icon: "error",
                  imageAlt: "The uploaded picture",
                });
              }
            })
            .catch((data) => {
              console.log("catch");
              console.log(data);
            });
        };
        reader.readAsDataURL(file);
      }
    },
    changeUserPass() {
      if (this.pass != this.pass1) {
        Swal.fire({
          title: "¡Atención!",
          text: "Las contraseñas no coinciden, intente nuevamente",
          icon: "warning",
        });
      } else {
        this.progress = true;
        let form = {
          id: this.id,
          params: {
            old_password: this.old_pass,
            new_password: this.pass,
          },
        };
        console.log(form);
        this.ChangePassword(form)
          .then((response) => {
            console.log(response);
            if (response.code == 200) {
              this.progress = false;
              this.$nextTick(() => {
                this.$bvModal.hide("modal-password");
              });
              Swal.fire({
                title: "Listo",
                text: "Su contraseña ha sido cambiada correctamente",
                icon: "success",
              });
            } else if ( response.code == 401 ){
              this.progress = false;
              this.$nextTick(() => {
                this.$bvModal.hide("modal-password");
              });
              Swal.fire({
                title: "¡Atención!",
                text: "La contraseña antigua no es correcta",
                icon: "warning",
              });
            }
          })
          .catch((error) => {
            this.progress = false;

            console.log(error);

            Swal.fire({
              title: "Error",
              text: "Ha ocurrido un error, intente más tarde",
              icon: "error",
            });
          });
      }
    },
    get2FA() {
      this.title = "Activar 2FA";
      this.Generate2FA(this.id)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            this.qr = response.data.qr_code;
            this.code = response.data.digit_key;
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        });
    },
    sendEmail() {
      this.SendEmail(this.id)
        .then((response) => {
          console.log(response);
          if (response.code == 200) {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
            Toast.fire({
              icon: "success",
              title: "Correo enviado!",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Error",
            text: "Ha ocurrido un error, intente más tarde",
            icon: "error",
          });
        });
    },
    Verificate2FA() {
      if (this.emailcode == "" || this.code2 == "") {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe completar los campos",
          icon: "warning",
        });
      } else {
        this.progress = true;
        let form = {
          id: this.id,
          params: {
            google_code: this.code2,
            verif_code: this.emailcode,
          },
        };
        if (this.disable) {
          this.Disable2FA(form)
            .then((response) => {
              console.log(response);
              if (response.code == 200) {
                Swal.fire({
                  title: "Listo",
                  text: "Ha deshabilitado el 2FA",
                  icon: "success",
                });
                Cookies.set("factor", 0)
                this.progress = false;
                this.$nextTick(() => {
                  this.$bvModal.hide("modal-2FA");
                });
                this.step = 1;
                this.getDataUser();
              } else if (
                response.message ==
                "The verification code you entered is not correct"
              ) {
                Swal.fire({
                  title: "Error",
                  text: "El código de verificación es incorrecto",
                  icon: "error",
                });
                this.progress = false;
              } else {
                Swal.fire({
                  title: "Error",
                  text: "El código de autentificación es incorrecto",
                  icon: "error",
                });
                this.progress = false;
              }
            })
            .catch((error) => {
              console.log(error);
              this.progress = false;

              Swal.fire({
                title: "Error",
                text: "Ha ocurrido un error, intente más tarde",
                icon: "error",
              });
            });
        } else {
          this.Enable2FA(form)
            .then((response) => {
              console.log(response);
              if (response.code == 200) {
                Swal.fire({
                  title: "Listo",
                  text: "Ha habilitado el 2FA",
                  icon: "success",
                });
                Cookies.set("factor", 1)
                this.progress = false;

                this.$nextTick(() => {
                  this.$bvModal.hide("modal-2FA");
                });
                this.step = 1;
                this.getDataUser();
              } else if (
                response.message ==
                "The verification code you entered is not correct"
              ) {
                this.progress = false;

                Swal.fire({
                  title: "Error",
                  text: "El código de verificación es incorrecto",
                  icon: "error",
                });
              } else {
                this.progress = false;

                Swal.fire({
                  title: "Error",
                  text: "El código de autentificación es incorrecto",
                  icon: "error",
                });
              }
            })
            .catch((error) => {
              console.log(error);
              Swal.fire({
                title: "Error",
                text: "Ha ocurrido un error, intente más tarde",
                icon: "error",
              });
            });
        }
      }
    },
    getCountry() {
      this.AllCountry().then((response) => {
        if (response.code == 200) {
          this.countries = response.data;
          this.countries.forEach((element) => {
            this.countryTmp.push({
              value: element.name_en,
              text: element.name_en,
            });
          });
        }
      });
    },
    getState() {
      this.AllStates().then((response) => {
        if (response.code == 200) {
          this.states = response.data;
          this.states.forEach((element) => {
            this.stateTmp.push({
              value: element.state,
              text: element.state,
            });
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.card-header:first-child {
  border-radius: 15px 15px 0 0;
}
</style>